module.exports = "/images/icon_google_white.png?9ccab3ce890dcff8417167b4d93fcc86";